import { render } from "./MapMarkerPopup.vue?vue&type=template&id=35675221&scoped=true"
import script from "./MapMarkerPopup.vue?vue&type=script&lang=js"
export * from "./MapMarkerPopup.vue?vue&type=script&lang=js"

import "./MapMarkerPopup.vue?vue&type=style&index=0&id=35675221&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mapalytics-frontend/mapalytics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35675221"]])

export default __exports__